import React from 'react';
import { SvgIcon } from '@material-ui/core';

const SortUp = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve0" d="M7173 2747l-1827 -1826c-124,-124 -328,-124 -452,0l-1827 1826c-124,125 -187,277 -187,453l0 1159c0,142 172,214 273,113l1327 -1327 0 5495c0,176 144,320 320,320l640 0c176,0 320,-144 320,-320l0 -5495 1327 1327c101,101 273,29 273,-113l0 -1159c0,-176 -63,-328 -187,-453z"/>
    </SvgIcon>
);
export default SortUp;

